module.exports = __webpack_public_path__ + "media/images/MRM-icon1-bd550936.png";